"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../../shared/components/table_actions/TableActionDelete");
var WrapTableActions_1 = require("../../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../../../shared/components/icons/FontAwesome");
var TableActionEdit_1 = require("../../../../../../../../shared/components/table_actions/TableActionEdit");
var TableMenuIsLocked_1 = require("../../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var UIUtils_1 = require("../../../../../../../../shared/modules/UIUtils");
var BrandAutoWithdrawsList = /** @class */ (function (_super) {
    __extends(BrandAutoWithdrawsList, _super);
    function BrandAutoWithdrawsList(props) {
        return _super.call(this, props) || this;
    }
    BrandAutoWithdrawsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandAutoWithdrawsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    BrandAutoWithdrawsList.prototype.doLockedAction = function (Key, Title, isLocked) {
        var _this = this;
        this.props.data.DoSetIsLocked(Key, isLocked, function () {
            if (isLocked) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430 ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D\u0430"));
            }
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    BrandAutoWithdrawsList.prototype.getColumns = function () {
        var _this = this;
        return ([{
                title: 'Валюта',
                dataIndex: this.props.data.dk_app_currency_title,
                key: this.props.data.dk_app_currency_title,
                width: 150,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        record.app_currency_title,
                        " ",
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "coins" })));
                }
            }, {
                title: 'Контроль суммы',
                dataIndex: this.props.data.dk_is_control_withdraw_amount,
                key: this.props.data.dk_is_control_withdraw_amount,
                width: 200,
                render: function (text, record, index) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_control_withdraw_amount, "ДА", "НЕТ")));
                }
            }, {
                title: 'Макс сумма',
                dataIndex: this.props.data.dk_max_withdraw_amount,
                key: this.props.data.dk_max_withdraw_amount,
                width: 200,
            }, {
                title: 'Контроль уровня',
                dataIndex: this.props.data.dk_is_control_player_level,
                key: this.props.data.dk_is_control_player_level,
                width: 200,
                render: function (text, record, index) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_control_player_level, "ДА", "НЕТ")));
                }
            }, {
                title: 'Мин. уровень',
                dataIndex: this.props.data.dk_min_withdraw_player_level_title,
                key: this.props.data.dk_min_withdraw_player_level_title,
                width: 200,
            }, {
                title: 'Контроль ин-аут %',
                dataIndex: this.props.data.dk_is_control_inout_percent,
                key: this.props.data.dk_is_control_inout_percent,
                width: 200,
                render: function (text, record, index) {
                    return (React.createElement("div", null, UIUtils_1.UIUtils.bool2Str(record.is_control_inout_percent, "ДА", "НЕТ")));
                }
            }, {
                title: 'Макс ин-аут %',
                dataIndex: this.props.data.dk_max_inout_percent_x100,
                key: this.props.data.dk_max_inout_percent_x100,
                width: 200,
            }, {
                title: 'Заблокирован',
                dataIndex: this.props.data.dk_is_locked,
                key: this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { unlockedTexts: { menu: "Разблокировать", text: "Нет" }, lockedTexts: { menu: "Заблокировать", text: "Да" }, record: { key: record.key, title: "Автовыплаты", locked: record.is_locked }, onLockClick: _this.doLockedAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditDataClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeletePlayerClick(record); } }))); },
                width: 80
            }]);
    };
    BrandAutoWithdrawsList.prototype.onEditDataClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    BrandAutoWithdrawsList.prototype.onDeletePlayerClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430"));
        });
    };
    BrandAutoWithdrawsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onCreateClick) {
                this.props.onCreateClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    BrandAutoWithdrawsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { bordered: true, columns: this.getColumns(), dataSource: this.state.data, locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, pagination: {
                    pageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return React.createElement("div", { style: { margin: 0 } },
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                        " [",
                        record.key,
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                        " [",
                        record.date_added2.format(_this.props.state.getDateTimeFormat()),
                        "] "),
                    React.createElement("div", null,
                        React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                        " [",
                        record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                        "]")); }, scroll: { x: true } })));
    };
    return BrandAutoWithdrawsList;
}(React.Component));
exports.default = BrandAutoWithdrawsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/auto_withdraws/BrandAutoWithdrawsList.tsx
// module id = 1801
// module chunks = 0